import { useState } from "react";
import type { ValidationError } from "@tanstack/react-form";
import { useForm } from "@tanstack/react-form";
import { useLocation } from "react-router-dom";

import { useForgotPassword } from "@/api/auth";
import { InsideLabelFieldInput } from "@/components/form";
import AuthPageTitle from "@/components/layout/auth-page-title";
import LoginReturnFooter from "@/components/layout/login-return-footer";
import { emailSchema, forgotPasswordSchema } from "@/schemas/auth";
import { stopPropagation } from "@/utils/form";

const ForgotPasswordEmailPage = () => {
  const { mutateAsync } = useForgotPassword();
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email ?? "");

  const { Field, Subscribe, handleSubmit } = useForm({
    defaultValues: { email: email ?? "" },
    validators: {
      onSubmit: ({ value }) => {
        const { email: emailValue } = value;
        const returnValue: { fields: { [k: string]: ValidationError } } = {
          fields: {},
        };
        if (!emailSchema.safeParse(emailValue).success) {
          const emailError: ValidationError = "Veuillez entrer un email valide";
          returnValue.fields["email"] = emailError;
        }
        return returnValue;
      },
    },
    onSubmit: async ({ value }) => {
      mutateAsync(value, {
        onSuccess: () => {
          setEmail(value.email);
        },
      });
    },
  });

  return (
    <form
      onSubmit={(e) => stopPropagation(e, handleSubmit)}
      className="grid grid-flow-row grid-cols-1 gap-12 pr-[112px] pl-[112px] w-full"
    >
      <AuthPageTitle
        title="Vérifiez vos emails"
        subTitle={"Nous avons envoyé un lien de réinitialisation à "}
        param={email}
      />

      <InsideLabelFieldInput
        Field={Field}
        name="email"
        label="Email"
        schema={forgotPasswordSchema}
        autoComplete="email"
        validators={{ onChange: forgotPasswordSchema.shape.email }}
      />

      <LoginReturnFooter
        title="Renvoyer un lien"
        beforeTitle="Vous n'avez rien reçu ?"
        Subscribe={Subscribe}
      />
    </form>
  );
};

export default ForgotPasswordEmailPage;
